<template>
  <div>
    <bm-text
      v-bind="$attrs"
      ref="barcodeScannerField"
      :value="value"
      :rules="computedRules"
      data-qa="scan_item_manual_input"
      clearable
      @keydown="$emit('keydown', $event)"
      @input="$emit('input', $event)"
      @blur="allowKeyboard = false"
    >
      <template #append-outer>
        <slot name="append-outer"></slot>
      </template>
    </bm-text>

    <slot name="action"></slot>
    <slot v-if="!disableCameraInput" name="scanner">
      <barcode-scanner2d
        :rules="computedRules"
        @valid-scanned="$emit('valid-scanned', $event)"
        @loading="$emit('loading', $event)"
      >
      </barcode-scanner2d>
    </slot>
  </div>
</template>

<script lang="ts">
import BmText from "@/components/controls/input/BmText.vue";
import BarcodeScanner2d from "@/components/controls/device/barcodes/BarcodeScanner2d.vue";
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { ValidationRule } from "@/plugins/validation";
export default defineComponent({
  name: "BmBarcodeCamera",
  components: { BarcodeScanner2d, BmText },
  props: {
    value: {
      type: String,
      default: "",
    },
    computedRules: {
      type: Array as PropType<ValidationRule[]>,
      default: () => [],
    },
    disableCameraInput: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allowKeyboard: false,
    };
  },
  methods: {
    manualInput(e: any) {
      // Allow keyboard input
      this.allowKeyboard = true;
    },
  },
});
</script>
